<template>
  <div class="studentTable">
    <div id="workingHoursInfo">
      <h6 class="workingHours">{{ $t(localeConsts.totalWorkingHours) }} {{ workingHoursTotal }}</h6>
      <p class="workingHours">|</p>
      <h6 class="workingHours">{{ $t(localeConsts.workingHoursPastSevenDays) }} {{ workHoursCurrentWeek }}</h6>
    </div>

    <b-table sort-by="task_start" sort-desc :items="tableData" :fields="columns" striped sticky-header>
      <template #cell(weekNumber)="data">
        <span>{{ data.value }}</span>
      </template>

      <template #cell(task_start)="data">
        {{ formatWorkReportDate(data.value) }}
      </template>

      <template #cell(task_duration)="data">
        {{ data.value }}
      </template>

      <template #cell(task)="data">
        <span class="textAreaSpan">{{ data.value }}</span>
      </template>

      <template #cell(results)="data">
        <span class="textAreaSpan">{{ data.value }}</span>
      </template>
    </b-table>
  </div>
</template>

<script>
import { generalHelperMethodsMixin } from '../../../mixins/generalHelperMethodsMixin'
import { filtersMixin } from '../../../mixins/filtersMixin'

import mapGettersMixin from '../../../mixins/mapGettersMixin'
import { workReportsMixin } from '../WorkReportsMixin'

export default {
  name: 'WorkReportsStudent',
  mixins: [generalHelperMethodsMixin, filtersMixin, workReportsMixin, mapGettersMixin],

  props: {
    userId: {
      type: [Number, String],
      required: true
    },

    week: {
      type: [Number, String],
      required: true
    }
  },

  data() {
    return {
      localeConsts: {
        workReportsDateColumn: 'WORKREPORTS.DATE',
        workReportsHoursColumn: 'WORKREPORTS.HOURS',
        workReportsDescriptionColumn: 'WORKREPORTS.DESCRIPTION',
        workReportsResultsColumn: 'WORKREPORTS.RESULTS',
        workingHoursPastSevenDays: 'WORKREPORTS.WORKINGHOURS_7DAYS',
        totalWorkingHours: 'WORKREPORTS.TOTAL_WORKINGHOURS'
      },

      fetchedData: [],
      tableData: []
    }
  },

  computed: {
    columns() {
      return [
        {
          label: 'PW',
          key: 'weekNumber',
          thClass: 'text-center studentTableThStyle',
          tdClass: 'text-center text-nowrap'
        },
        {
          key: 'task_start',
          label: this.$i18n.t(this.localeConsts.workReportsDateColumn),
          thClass: 'text-center studentTableThStyle',
          tdClass: 'text-center text-nowrap'
        },

        {
          key: 'task_duration',
          label: this.$i18n.t(this.localeConsts.workReportsHoursColumn),
          thClass: 'text-center studentTableThStyle',
          tdClass: 'text-center text-nowrap'
        },

        {
          key: 'task',
          label: this.$i18n.t(this.localeConsts.workReportsDescriptionColumn),
          thClass: 'text-center studentTableThStyle',
          tdClass: 'text-center'
        },

        {
          key: 'results',
          label: this.$i18n.t(this.localeConsts.workReportsResultsColumn),
          thClass: 'text-center studentTableThStyle',
          tdClass: 'text-center'
        }
      ]
    },

    workHoursCurrentWeek() {
      return this.getWorkHoursPerWeekAndByUserId(this.fetchedData, this.week, this.userId)
    },

    workingHoursTotal() {
      return this.getWorkHoursPerWeekAndByUserId(this.fetchedData, undefined, this.userId)
    }
  },

  watch: {
    week: {
      deep: true,
      handler() {
        this.getReportsAndFilterByWeekAndUserId()
      }
    }
  },

  mounted() {
    this.getReportsAndFilterByWeekAndUserId()
  }
}
</script>

<style lang="scss">
$text-color: #8b69a9;
$th-color: #451a6e;
$th-background-color: #c1afd1;

/*working hours*/

#workingHoursInfo {
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
  margin-bottom: 10px;
}

.workingHours {
  display: inline;
  color: $text-color;
  margin-right: 10px;
}

/*student table*/

.table .studentTableThStyle {
  color: $th-color !important;
  background-color: $th-background-color !important;
}

/*textArea styling*/

.textAreaSpan {
  line-break: anywhere;
  white-space: pre-wrap;
}
</style>
